/**
 * Angular `policy-declaration-addedit.component.html` — Available Variables lists (comma-separated in Angular).
 */
export const TERMS_SECTION1_AVAILABLE_VARIABLES: readonly string[] = [
  'policy_id',
  'company_name',
  'company_address',
  'policy_start_date',
  'policy_end_date',
]

export const TERMS_SECTION2_AVAILABLE_VARIABLES: readonly string[] = [
  'policy_id',
  'company_name',
  'company_address',
  'policy_start_date',
  'policy_end_date',
  'declaration_resident',
  'applicant_id',
  'property_name',
  'property_landlord_name',
  'property_address',
  'property_unit',
  'all_applicants_name',
  'lease_start_date',
  'lease_end_date',
  'rent_amount',
  'rental_status',
  'rental_progress',
  'report_date',
]
